var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalaryImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_5902)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2216_5902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.83333C17.5 7.29167 17.125 7.66667 16.6667 7.66667H14.15C13.9333 10.9167 11.2167 13.5 7.91667 13.5H5.66667L13.025 19.525C13.3833 19.8167 13.4333 20.3417 13.1417 20.7C12.975 20.9 12.7333 21.0083 12.4917 21.0083C12.3083 21.0083 12.1167 20.95 11.9667 20.8167L2.80833 13.3083C2.53333 13.0833 2.43333 12.7167 2.55 12.3833C2.66667 12.05 2.98333 11.8333 3.33333 11.8333H7.91667C10.3 11.8333 12.2667 10 12.4833 7.66667H3.33333C2.875 7.66667 2.5 7.29167 2.5 6.83333C2.5 6.375 2.875 6 3.33333 6H12.325C11.7833 4.075 10.0083 2.66667 7.91667 2.66667H3.33333C2.875 2.66667 2.5 2.29167 2.5 1.83333C2.5 1.375 2.875 1 3.33333 1H16.6667C17.125 1 17.5 1.375 17.5 1.83333C17.5 2.29167 17.125 2.66667 16.6667 2.66667H12.1583C13.1 3.54167 13.775 4.7 14.0333 6H16.6583C17.1167 6 17.4917 6.375 17.4917 6.83333H17.5Z",
    fill: "#3D3E58"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_5902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6667,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2216_5902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryImg);
export default __webpack_public_path__ + "static/media/SalaryImg.ce538a0c47b623c7a8a99dc06d27cd4a.svg";
export { ForwardRef as ReactComponent };